<template>
    <div id="OffshoreInfo">
        <SelectBox
            :data="selectBoxData"
            :style="{margin: '20px auto'}"
            @getClick="getClick"/>
        <div class="info-content">
            <div class="info-title">舟山钓场情况</div>
            <div class="select-nav">
                <div
                    class="select-nav-item"
                    v-for="(item, index) of selectNav"
                    :key="index">
                    <div :class="item.focus ? 'focus' : null" @click="selectItem(item)">{{item.name}}</div>
                    <div><img :src="item.icon ? item.icon : null" alt=""></div>
                    <span v-show="index !== selectNav.length - 1">|</span>
                </div>
            </div>
            <div class="info-box">
                <div class="info-left">
                    <div
                        class="info-item"
                        v-for="(item, index) of fishingList"
                        @click="select(item)"
                        :key="index">
                        <div class="item-box">
                            <img :src="item.imgUrl" alt="">
                        </div>
                        <div class="item-info">
                            <div class="item-info-title">
                                <span>{{item.name}}</span>
                                <div @click.stop="changeMap(item)">
                                    <img
                                        :src="item.focus ? require('../../assets/img/地图聚焦.png') :  require('../../assets/img/地图.png')"
                                        alt="">
                                    <span :style="item.focus ? {color: 'rgba(5,160,130,1)'}: {}">地图</span>
                                </div>
                            </div>
                            <p>地址: {{item.address}}</p>
                            <p>类型: {{item.type}}</p>
                            <div class="item-info-tel">
                                <div>
                                    <span>{{item.tel}}</span>
                                    <img src="../../assets/img/问号.png" alt="">
                                </div>
                                <div>
                                    <img src="../../assets/img/reads.png" alt="">
                                    <span>{{item.reads}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-right">
                    <div class="map" id="map"></div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next"
                @current-change="currentChange"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import SelectBox from '../../components/select-box/SelectBox'
    import { MP } from '../../assets/js/map.js'

    export default {
        name: 'OffshoreInfo',
        components: {
            SelectBox
        },
        data() {
            return {
                selectBoxData: {
                    // 区域: [
                    //     {name: '定海区'},
                    //     {name: '岱山县'},
                    //     {name: '普陀区'},
                    //     {name: '普陀区'}
                    // ],
                    // 分类: [
                    //     {name: '斤塘'},
                    //     {name: '天塘'},
                    //     {name: '农家乐'},
                    //     {name: '野塘'}
                    // ]
                },
                selectNav: [
                    {
                        name: '默认排序',
                        focus: false
                    },
                    {
                        name: '发布时间',
                        icon: require('../../assets/img/发布时间1.png'),
                        selectIcon: require('../../assets/img/发布时间2.png'),
                        focus: false
                    }
                ],
                fishingList: [],
                testList: [
                    {
                        title: '海礁海钓 海礁船钓 浙江舟山梦幻钓场海礁船钓2~3天',
                        address: '桃花岛',
                        type: '斤塘',
                        tel: '1**********',
                        img: require('../../assets/img/pic1.png'),
                        reads: 253
                    },
                    {
                        title: '海礁海钓 海礁船钓 浙江舟山梦幻钓场海礁船钓2~3天',
                        address: '桃花岛',
                        type: '斤塘',
                        tel: '1**********',
                        img: require('../../assets/img/pic2.png'),
                        reads: 253
                    },
                    {
                        title: '海礁海钓 海礁船钓 浙江舟山梦幻钓场海礁船钓2~3天',
                        address: '桃花岛',
                        type: '斤塘',
                        tel: '1**********',
                        img: require('../../assets/img/pic3.png'),
                        reads: 253
                    },
                    {
                        title: '海礁海钓 海礁船钓 浙江舟山梦幻钓场海礁船钓2~3天',
                        address: '桃花岛',
                        type: '斤塘',
                        tel: '1**********',
                        img: require('../../assets/img/pic4.png'),
                        reads: 555
                    }
                ],
                // 筛选信息
                form: {
                    area: '',
                    type: '',
                    pageNum: '1',
                    pageSize: '10'
                },
                // 总条数
                total: 0
            }
        },
        methods: {
            /**
             * 选择的选项
             */
            selectItem(item) {
                this.selectNav.map(data => {
                    this.$set(data, 'focus', false)
                })
                this.$set(item, 'focus', true)
                // item.focus = true
            },
            // 获得地图
            getMap(x, y, name) {
                let map = new BMap.Map('map')
                let point = null
                let title = null
                if (x && y) {
                    point = new BMap.Point(x, y)
                    title = name
                } else {
                    point = new BMap.Point(122.195884, 30.179534)
                    title = '舟山海钓'
                }
                // let point = new BMap.Point(122.195884, 30.179534)
                // 创建标注
                let marker = new BMap.Marker(point)
                let opts = {
                    width: 100,
                    height: 50
                    // title: 'Hello'
                }
                // 创建信息窗口对象
                let infoWindow = new BMap.InfoWindow(title, opts)
                map.addOverlay(marker)
                map.centerAndZoom(point, 12)
                // 打开信息窗口
                map.openInfoWindow(infoWindow, map.getCenter())
                marker.addEventListener('click', function () {
                    map.openInfoWindow(infoWindow, map.getCenter())
                })
            },
            /**
             * 选中列表信息
             */
            select(item) {
                this.$router.push({path: '/MapDetails', query: {...item}})
            },
            // 切换地图
            changeMap(item) {
                console.log(item)
                this.fishingList.map(data => {
                    this.$set(data, 'focus', false)
                })
                this.$set(item, 'focus', true)
                if (!item.x) {
                    this.$message.error('此钓场还没有添加地图信息')
                } else {
                    this.getMap(item.x, item.y, item.name)
                }
            },
            /**
             * 获得地区信息
             */
            getArea() {
                this.$common.post('/portal/getCity').then(res => {
                    console.log(res)
                    this.$set(this.selectBoxData, '区域', res.data)
                    // this.selectBoxData['区域'] = res.data
                })
            },
            /**
             * 获得钓场信息
             */
            getFishingsiteType() {
                this.$common.post('/portal/getFishsiteType').then(res => {
                    this.$set(this.selectBoxData, '分类', res.data)
                    // this.selectBoxData['分类'] = res.data
                })
            },
            getClick(item, key) {
                console.log(item, key)
                if (key === '区域') {
                    this.form.area = item.dictValue
                } else if (key === '分类') {
                    this.form.type = item.dictValue
                }
                this.getFinshingList()
            },
            getFinshingList() {
                this.$common.post('/portal/getHdBaseFishsite', this.form).then(res => {
                    this.fishingList = res.data.rows
                    this.total = res.data.total
                })
            },
            currentChange(pageNum) {
                console.log(pageNum)
                this.form.pageNum = pageNum
                this.getFinshingList()
            }
        },
        created() {
            this.getArea()
            this.getFishingsiteType()
            this.getFinshingList()
        },
        mounted() {
            this.$nextTick(() => {
                MP().then(BMap => {
                    this.getMap()
                })
            })
        }
    }
</script>

<style scoped lang="less">
    #OffshoreInfo {
        .info-content {
            margin: 25px auto;
            width: 1200px;

            .info-title {
                height: 18px;
                line-height: 18px;
                font-size: 18px;
            }

            .select-nav {
                width: 65%;
                margin-top: 23px;
                display: flex;
                justify-content: flex-start;
                align-content: center;
                height: 22px;
                border-bottom: 1px solid rgba(221, 221, 221, 1);

                .select-nav-item {
                    align-content: center;
                    height: 100%;
                    display: flex;
                    justify-content: flex-start;
                    cursor: pointer;

                    > div:nth-of-type(1) {
                        &:hover {
                            color: rgba(5, 160, 130, 1);
                        }
                    }

                    .focus {
                        color: rgba(5, 160, 130, 1);
                        border-bottom: 1px solid rgba(5, 160, 130, 1);
                    }

                    > span {
                        margin: 0 35px;
                        color: rgba(204, 204, 204, 1)
                    }

                    img {
                        margin-left: 5px;
                    }
                }
            }

            .info-box {
                width: 1200px;
                display: flex;
                justify-content: space-between;
            }

            .info-left {
                width: 65%;

                .info-item {
                    margin-top: 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .item-box {
                        width: 220px;
                        height: 140px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 100%;
                            height: 100%;
                            transition: all 1s;

                            &:hover {
                                transform: scale(1.4);
                            }
                        }
                    }

                    .item-info {
                        width: calc(100% - 250px);
                        height: 140px;

                        > div {
                            margin-top: 20px;
                        }

                        > p {
                            margin-top: 15px;
                        }

                        .item-info-title {
                            display: flex;
                            justify-content: space-between;

                            > span {
                                font-weight: bold;
                                font-size: 18px;

                                &:hover {
                                    color: rgba(5, 160, 130, 1);
                                }
                            }

                            > div {
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                > img {
                                    margin: 0 5px;
                                }
                            }
                        }

                        .item-info-tel {
                            display: flex;
                            justify-content: space-between;

                            > div {
                                display: flex;
                                align-items: center;

                                > img {
                                    margin: 0 5px;
                                }
                            }
                        }
                    }
                }
            }

            .info-right {
                width: 32%;

                .map {
                    height: 300px;
                    width: 300px;
                    background: pink;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/index-nav/OffshoreInfo.vue